export default "__VITE_ASSET__Bugzw5H4__"